var envService = (function () {

    var _environments = {
        stp: {
            env: 'stp',
            config: {
                apiroot: 'https://stpfast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://stp.cvsspecialty.com",
                smagentname: "portal8-webagent-reg",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://stpdepservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                }
            }
        },
        dev1: {
            env: 'dev1',
            config: {
                apiroot: 'https://dev1fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://dev1www.cvsspecialty.com",
                smagentname: "portal8-webagent-dev1",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://dev1depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                }
            }
        },
        dev2: {
            env: 'dev2',
            config: {
                apiroot: 'https://dev2fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://dev2www.cvsspecialty.com",
                smagentname: "portal8-webagent-dev2",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://dev2depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                }
            }
        },
        dev3: {
            env: 'dev3',
            config: {
                apiroot: 'https://dev3fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://dev3www.cvsspecialty.com",
                smagentname: "portal8-webagent-dev3",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://dev3depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                }
            }
        },
        sit1www: {
            env: 'sit1www',
            config: {
                apiroot: 'https://sit1fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://sit1www.cvsspecialty.com",
                smagentname: "portal8-webagent-sit1",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://sit1depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-sit1.corp.cvscaremark.com:1443/dswebservices'
                }
            }
        },
        sit2www: {
            env: 'sit2www',
            config: {
                apiroot: 'https://sit2fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://sit2www.cvsspecialty.com",
                smagentname: "portal8-webagent-sit2",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://sit2depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-sit2.corp.cvscaremark.com:1443/specialty/ssotokenService'
                }
            }
        },
        sit3www: {
            env: 'sit3www',
            config: {
                apiroot: 'https://sit3fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://sit3www.cvsspecialty.com",
                smagentname: "portal8-webagent-sit3",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "37da5716-0a2b-4f59-9bfc-a4beefc27be3",
                    "apiSecret": '27cff53b-899d-41f6-9fa0-e1fc309fe64b',
                    "serviceURL": 'https://sit3depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-sit3.corp.cvscaremark.com:1443/dswebservices'
                }
            }
        },
        www: {
            env: 'prod',
            config: {
                apiroot: 'https://fast.cvsspecialty.com/api/',
                apikey: 'ad4154dd-88b4-451c-81a2-4fa49da9cdba',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://www.cvsspecialty.com",
                smagentname: "speciality-portal-webagent",
                epicConfig: {
                    "epicURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "1c1b9a77-d806-45c0-8718-e16179c06081",
                    "apiSecret": '25e302a4-9569-42d2-8853-26e35a880e2b',
                    "serviceURL": 'https://depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-prodw.corp.cvscaremark.com:1443/dswebservices'
                }
            }
        },
        fast: {
            env: 'prod',
            config: {
                apiroot: 'https://fast.cvsspecialty.com/api/',
                apikey: 'ad4154dd-88b4-451c-81a2-4fa49da9cdba',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://www.cvsspecialty.com",
                smagentname: "speciality-portal-webagent",
                epicConfig: {
                    "epicURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "1c1b9a77-d806-45c0-8718-e16179c06081",
                    "apiSecret": '25e302a4-9569-42d2-8853-26e35a880e2b',
                    "serviceURL": 'https://depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-prodw.corp.cvscaremark.com:1443/dswebservices'
                }
            }
        },
        prod: {
            env: 'prod',
            config: {
                apiroot: 'https://fast.cvsspecialty.com/api/',
                apikey: 'ad4154dd-88b4-451c-81a2-4fa49da9cdba',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://www.cvsspecialty.com",
                smagentname: "speciality-portal-webagent",
                epicConfig: {
                    "epicURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "1c1b9a77-d806-45c0-8718-e16179c06081",
                    "apiSecret": '25e302a4-9569-42d2-8853-26e35a880e2b',
                    "serviceURL": 'https://depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-prodw.corp.cvscaremark.com:1443/dswebservices'
                }
            }
        },
        care: {
            env: 'prod',
            config: {
                apiroot: 'https://fast.cvsspecialty.com/api/',
                apikey: 'ad4154dd-88b4-451c-81a2-4fa49da9cdba',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://www.cvsspecialty.com",
                smagentname: "speciality-portal-webagent",
                epicConfig: {
                    "epicURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart.cvsspecialty.com/specialty-mychart/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart.cvsspecialty.com/specialty-mychart/cvserr.asp?msg=cvscode01&action=status"
                },
                secureChatConfig: {
                    "apiKey": "1c1b9a77-d806-45c0-8718-e16179c06081",
                    "apiSecret": '25e302a4-9569-42d2-8853-26e35a880e2b',
                    "serviceURL": 'https://depservices.cvs.com/secureChat/trustedAuthenticate?version=1.0'
                },
                pbmMicroServiceConfig: {
                    "serviceURL": 'https://pbmmicrosvcs-prodw.corp.cvscaremark.com:1443/dswebservices'
                }
            }
        },
        local: {
            env: 'local',
            config: {
                apiroot: 'http://localhost:1450/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://dev1www.cvsspecialty.com",
                smagentname: "speciality-portal-webagent",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                }
            }
        },
        devint: {
            env: 'devint',
            config: {
                apiroot: 'https://dev1fast.cvsspecialty.com/api/',
                apikey: 'd489fa90-8423-4db8-a11f-ff8f29ebdb19',
                tSwitch: true,
                tokenId: "",
                mobileAppStyle: false,
                source: "",
                accessKey: "",
                parentHost: "https://dev1www.cvsspecialty.com",
                smagentname: "",
                epicConfig: {
                    "epicURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login?IdP=CVSSPECIALTY",
                    "epicSAMLPostURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/Authentication/Saml/Login",
                    "epicTokenMissingErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status",
                    "epicReqErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode02&action=status",
                    "epicServiceErrorURL": "https://mychart-uat.cvsspecialty.com/specialty-mychart-tst/cvserr.asp?msg=cvscode01&action=status"
                }
            }
        }
    }
    return {

        env: null,
        apikey: null,
        channel: null,
        tokenId: null,
        tSwitch: true,
        parentHost: null,
        accessKey: null,
        source: null,
        mobileAppStyle: false,
        smagentname: null,

        getEnvironment: function () {
            this.env = this.getParameterByName('env') || window.location.hostname;
            if (this.env === 'localhost' || this.env === 'local')
                envStr = "local";
            else {
                // var envStr = this.env.substring(0,4);
                var envStr = window.location.hostname.split('.')[0];
                envStr = envStr.replace('static', 'www');
                if (envStr.indexOf('fast') > 0) {
                    envStr = envStr.replace('fast', 'www');
                }
                else if (envStr === 'sit1' || envStr === 'sit2' || envStr === 'sit3') {
                    envStr += 'www';
                }

            }

            return _environments[envStr].env;
        },
        getapikey: function () {
            this.apikey = this.getParameterByName('apikey') || this.get('apikey');
            return this.apikey;
        },
        getChannel: function () {
            this.channel = this.getParameterByName('channel') || this.getUserAgent();
            return this.channel;
        },
        getTSwitch: function () {
            this.tSwitch = this.getParameterByName('tSwitch') || this.get('tSwitch');
            return this.tSwitch;
        },
        getTokenId: function () {
            this.tokenId = this.getParameterByName('tokenId') || this.get('tokenId');
            return this.tokenId;
        },
        getParentHost: function () {
            this.parentHost = this.getParameterByName('parentHost') || this.get('parentHost');
            return this.parentHost;
        },
        getParameterByName: function (name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },
        getUserAgent: function () {
            // https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Web_MobAnd";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "Web_MobIOS";
            }

            return "Web";
        },
        getAccessKey: function () {
            this.accessKey = this.getParameterByName('accessKey') || this.get('accessKey');
            return this.accessKey
        },
        getSource: function () {
            this.source = this.getParameterByName('source') || this.get('source');
            return this.source
        },
        getSmagentname: function () {
            this.smagentname = this.getParameterByName('smagentname') || this.get('smagentname');
            return this.smagentname
        },
        getAppStyle: function () {
            this.mobileAppStyle = this.getParameterByName('mobileAppStyle') || this.get('mobileAppStyle');
            return this.mobileAppStyle;
        },
        getHashkey: function () {
            this.hashkey = this.getParameterByName('hashkey');
            return this.hashkey;
        },
        getTimestamp: function () {
            this.timestamp = this.getParameterByName('timestamp');
            return this.timestamp;
        },
        getEpicConfig: function () {
            this.epicConfig = this.get('epicConfig');
            return this.epicConfig;
        },
        get: function (property) {
            return _environments[this.getEnvironment()].config[property];
        },
        getSecureChatConfig: function () {
            this.secureChatConfig = this.get('secureChatConfig');
            return this.secureChatConfig;
        },
        getpbmMicroServiceConfig: function () {
            this.pbmMicroServiceConfig = this.get('pbmMicroServiceConfig');
            return this.pbmMicroServiceConfig;
        }
    }

})();

